module.exports = __webpack_public_path__ + "img/auction-6.4311b045.png";